import * as React from "react";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import PrwcBasicButton from "../../../../../../../ui/widgets/custom/buttons/PrwcBasicButton";
import PrwcSidebar from "../../../../../../../ui/widgets/custom/PrwcSidebar";
import PrwcSplitButton from "../../../../../../../ui/widgets/custom/PrwcSplitButton";
import { OperationType } from "../../../user-categories/models/enums/user-categories-generic.enums";
import BulkUsersContainer from "../../containers/BulkUsersContainer";
import UserContainer from "../../containers/UserContainer";
import UserListContainer from "../../containers/UserListContainer";
import { UserGenericConstants } from "../../models/constants/user-generic.constants";

const UsersPage = () => {
  const { t } = useTranslation();
  const [isSideBarVisible, setIsSideBarVisible] = useState(false);
  const [operationType, setOperationType] = useState(OperationType.ADD);
  const [selectedRowData, setSelectedRowData] = useState(null);
  const [areSectionsExpanded, setAreSectionsExpanded] = useState(false);
  const [activeSections, setActiveSections] = useState([0]);
  const [isBulkUserDialogOpen, setIsBulkUserDialogOpen] = useState(false);

  const items = [
    {
      label: t("users.action.addInBulk"),
      icon: "pi pi-upload",
      command: () => {
        handleAddBulkUsers();
      },
    },
  ];

  const handleAddBulkUsers = () => {
    setIsBulkUserDialogOpen(true);
  };

  const onHideBulkUsers = () => {
    setIsBulkUserDialogOpen(false);
  };

  const handleAddUser = () => {
    setOperationType(OperationType.ADD);
    setSelectedRowData(null);
    setIsSideBarVisible(true);
  };

  const handleEditUser = (rowData: any) => {
    setOperationType(OperationType.EDIT);
    setSelectedRowData(rowData);
    setIsSideBarVisible(true);
  };

  const handleExpandAllSections = () => {
    setActiveSections(UserGenericConstants.Sections.ALL);
    setAreSectionsExpanded(true);
  };

  const handleCollapseAllSections = () => {
    setActiveSections(UserGenericConstants.Sections.NONE);
    setAreSectionsExpanded(false);
  };

  const handleOnHide = () => {
    setActiveSections(UserGenericConstants.Sections.RESET);
    setAreSectionsExpanded(false);
    setIsSideBarVisible(false);
  };

  const headerButtons = () => {
    return (
      <>
        {areSectionsExpanded ? (
          <PrwcBasicButton
            icon="pi pi-minus"
            className="p-button-rounded p-button-text p-button-secondary"
            onClick={handleCollapseAllSections}
            tooltipText={t("generic.action.collapseAll")}
          ></PrwcBasicButton>
        ) : (
          <PrwcBasicButton
            icon="pi pi-plus"
            className="p-button-rounded p-button-text p-button-secondary"
            onClick={handleExpandAllSections}
            tooltipText={t("generic.action.expandAll")}
          ></PrwcBasicButton>
        )}
      </>
    );
  };

  return (
    <div>
      <BulkUsersContainer
        isVisible={isBulkUserDialogOpen}
        onHide={onHideBulkUsers}
      ></BulkUsersContainer>

      <div className="flex items-center justify-between px-2 border-gray-300">
        <div className="text-2xl font-semibold text-gray-700 ">
          {t("users.label.users")}
        </div>
        <div>
          <PrwcSplitButton
            labelKey="users.action.addUser"
            model={items}
            onClick={handleAddUser}
          ></PrwcSplitButton>
        </div>
      </div>

      <PrwcSidebar
        headerTitle={
          operationType === OperationType.ADD
            ? t("users.label.addUser")
            : t("users.label.editUser")
        }
        isSideBarVisible={isSideBarVisible}
        enableFullScreen={true}
        position="right"
        className="p-sidebar-md"
        onHide={handleOnHide}
        headerButtons={headerButtons}
      >
        <UserContainer
          operationType={operationType}
          data={selectedRowData}
          activeSections={activeSections}
          setActiveSections={setActiveSections}
        ></UserContainer>
      </PrwcSidebar>
      <UserListContainer onEdit={handleEditUser}></UserListContainer>
    </div>
  );
};

export default UsersPage;
